// extracted by mini-css-extract-plugin
export default {"root":"order-book-groupings_root__ScV8-","label":"order-book-groupings_label__hypT1"};